import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { LoadHealthInsurerLogo } from 'src/app/store/actions/document.action';
import { DocumentUrlWithKey, healthInsurerLogoById } from 'src/app/store/reducer/document.reducer';

@Component({
    standalone: false,
    selector: 'app-health-insurer-card',
    templateUrl: './health-insurer-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HealthInsurerCardComponent {
    @Input() set healthInsurerId(_healthInsurerId: string) {
        if (_healthInsurerId) {
            this.store
                .select(healthInsurerLogoById(_healthInsurerId))
                .pipe(take(1))
                .subscribe((logo) => {
                    if (!logo) {
                        this.store.dispatch(LoadHealthInsurerLogo({ healthInsurerId: _healthInsurerId }));
                    }
                });

            this.logo$ = this.store.select(healthInsurerLogoById(_healthInsurerId));
        }
    }

    /** Shown when the insurer has no logo. */
    @Input() initials = '';

    logo$: Observable<DocumentUrlWithKey>;

    constructor(private store: Store) {}
}
